// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractModuleUi } from '../_abstract/ui';
import { ImageRatio, ModuleDriver } from '../_contracts';
import { prepareImage } from '../_filters';
import { BootstrapImage } from '../../dsl/bootstrap';
import { AdBannerModuleUi } from '../AdBanner/AdBanner.ui';
let FullpageAdModuleUi = class FullpageAdModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        this.bgImage = null;
        this.adModule = null;
        this.bgModule = null;
    }
    fetchRelated() {
        this.resolveBackgroundImage();
        this.adModule = this.resolveSnippet(this.module.content.ad);
        this.bgModule = this.resolveSnippet(this.module.content.slot);
    }
    resolveBackgroundImage() {
        if (!this.module.content.image) {
            return;
        }
        const imageFile = this.relatedService.resolveSync(this.module.content.image);
        if (!imageFile) {
            return;
        }
        const maxWidth = this.isMobile ? 768 : 1920;
        this.bgImage = prepareImage(imageFile, ImageRatio.Original, maxWidth, false);
    }
    resolveSnippet(related) {
        var _a;
        if (!related) {
            return null;
        }
        const snippet = this.relatedService.resolveSync(related);
        if (!snippet) {
            return null;
        }
        return (_a = snippet.modules.find(m => m.driver === ModuleDriver.AdBanner)) !== null && _a !== void 0 ? _a : null;
    }
};
FullpageAdModuleUi = __decorate([
    Component({
        name: 'FullpageAdModuleUi',
        components: {
            AdBannerModuleUi,
            BootstrapImage
        },
        template: `
    <div class="fullpageAd-module">
      <AdBannerModuleUi v-if="adModule" :module="adModule" v-bind="{ relatedService, windowService, eventBus, isMobile }" />

      <div class="fullpageAd__bg" :style="{ backgroundColor: module.content.color }">
        <BootstrapImage v-if="bgImage" v-bind="bgImage" class="fullpageAd__bg__image" fetchpriority="high" @load="onReady" />

        <div v-else-if="bgModule" class="fullpageAd__bg__slot">
          <AdBannerModuleUi :module="bgModule" v-bind="{ relatedService, windowService, eventBus, isMobile }" />
        </div>
      </div>
    </div>
  `,
        created() {
            this.fetchRelated();
        }
    })
], FullpageAdModuleUi);
export { FullpageAdModuleUi };
